import { animation, animate, style } from '@angular/animations';

export namespace AnimationLib {

  export const slideTransition = animation([
    style({
      transform: `translateY({{ from }}%)`,
      opacity: 0
    }),
    animate(`{{ duration }}ms ease-out`, style({
      transform: `translateY({{ to }})`,
      opacity: 1
    }))
  ]);

  export const fadeIn = animation([
    style({
      opacity: 0
    }),
    animate(`{{ duration }}ms ease-out`, style({
      opacity: 1
    }))
  ]);

  export const fadeOut = animation([
    style({
      opacity: '*'
    }),
    animate(`{{ duration }}ms ease-in`, style({
      opacity: 0
    }))
  ]);
}
